var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExamLandingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.325,
    cy: 11.7679,
    r: 11.2181,
    fill: "#E05E00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_437_12613",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.70947,
    y: 2.15234,
    width: 19.231,
    height: 19.231,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_437_12613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3249 18.0581L6.11651 15.2336V10.8866L3.35205 9.36411L11.3249 5.01709L19.2978 9.36411V15.1334H18.0959V10.0252L16.5333 10.8866V15.2336L11.3249 18.0581ZM11.3249 12.3289L16.8138 9.36411L11.3249 6.39932L5.83606 9.36411L11.3249 12.3289ZM11.3249 16.6959L15.3314 14.5324V11.5276L11.3249 13.7111L7.31845 11.5276V14.5324L11.3249 16.6959Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamLandingIcon);
export default __webpack_public_path__ + "static/media/exam-landing-icon.74a019bfcef39fb5816a5716cd496f0f.svg";
export { ForwardRef as ReactComponent };